/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateLabelRequestLabel,
  UpdateLabelRequestLabelFromJSON,
  UpdateLabelRequestLabelFromJSONTyped,
  UpdateLabelRequestLabelToJSON
} from './UpdateLabelRequestLabel'

/**
 *
 * @export
 * @interface UpdateLabelRequest
 */
export interface UpdateLabelRequest {
  /**
   *
   * @type {UpdateLabelRequestLabel}
   * @memberof UpdateLabelRequest
   */
  label?: UpdateLabelRequestLabel
}

export function UpdateLabelRequestFromJSON(json: any): UpdateLabelRequest {
  return UpdateLabelRequestFromJSONTyped(json, false)
}

export function UpdateLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLabelRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    label: !exists(json, 'label') ? undefined : UpdateLabelRequestLabelFromJSON(json['label'])
  }
}

export function UpdateLabelRequestToJSON(value?: UpdateLabelRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    label: UpdateLabelRequestLabelToJSON(value.label)
  }
}
